// Section height adjusters relocated from inline page <script> blocks (F20).
// Each function is scoped to its page via the unique <main> class, so the
// shared container ids (#blog-parent lives on both the homepage and the
// reference page with different logic) resolve to the right page's behaviour.
// getWidth() is provided globally by site.js (window.getWidth).

function getAbsoluteHeight(el) {
  el = (typeof el === 'string') ? document.querySelector(el) : el;

  const styles = window.getComputedStyle(el);
  const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

  return Math.ceil(el.offsetHeight + margin);
}

// Homepage blog section (#blog-parent inside .homepage)
function resizeHomepageBlog() {
  const parent = document.querySelector('.homepage #blog-parent');
  if (!parent) {
    return;
  }

  parent.style.maxHeight = '5000px';
  const child1 = parent.getElementsByClassName('wrapper')[0];
  const child2 = parent.getElementsByClassName('wrapper')[1];
  let height = getAbsoluteHeight(child1);
  if (child2) {
    height += getAbsoluteHeight(child2);
  }

  if (window.getWidth() > 922) {
    parent.style.maxHeight = height - 450 + 'px';
  } else {
    parent.style.maxHeight = height - 300 + 'px';
  }
}

// Reference blog section (#blog-parent inside .reference)
function resizeReferenceBlog() {
  const parent = document.querySelector('.reference #blog-parent');
  if (!parent) {
    return;
  }

  const wrappers = parent.getElementsByClassName('wrapper');
  for (let i = 0; i < wrappers.length; i++) {
    const child = wrappers[i];
    parent.style.maxHeight = '5000px';
    parent.style.height = (child.offsetHeight) - 150 + 'px';
  }
}

// Campaign detail similar-campaigns section (#similar-parent)
function resizeSimilar() {
  const parent = document.getElementById('similar-parent');
  if (!parent) {
    return;
  }

  const child = parent.getElementsByClassName('wrapper')[0];
  parent.style.height = child.offsetHeight - 80 + 'px';
}

// Blog posts list (#posts-parent inside .blog)
function resizeBlogPosts() {
  const parent = document.getElementById('posts-parent');
  if (!parent) {
    return;
  }

  parent.style.maxHeight = '7000px';
  const child = parent.getElementsByClassName('wrapper')[0];
  parent.style.height = child.offsetHeight - 160 + 'px';
}

// Career open-positions list (.position inside .career)
function adjustPositionHeight() {
  const position = document.querySelector('.career .position');
  if (!position) {
    return;
  }

  const items = document.querySelectorAll('.career .position .item');
  const totalHeight = Array.from(items).reduce((sum, item) => sum + item.offsetHeight, 0);
  if (window.innerWidth <= 1149) {
    position.style.height = totalHeight + 20 + 'px';
  } else {
    position.style.height = '350px';
  }
}

// Collaboration campaign list (.campaign inside .collaboration)
function adjustCampaignHeight() {
  const campaign = document.querySelector('.collaboration .campaign');
  if (!campaign) {
    return;
  }

  const items = document.querySelectorAll('.collaboration .campaign .item');
  const totalHeight = Array.from(items).reduce((sum, item) => sum + item.offsetHeight, 0);
  if (window.innerWidth <= 1149) {
    campaign.style.height = totalHeight + 60 + 'px';
  } else {
    campaign.style.height = '1030px';
  }
}

// Wiring preserves each former inline script's exact timing.

// Homepage blog: immediate + 500ms + resize + load
resizeHomepageBlog();
setTimeout(resizeHomepageBlog, 500);
window.addEventListener('resize', resizeHomepageBlog);
window.addEventListener('load', resizeHomepageBlog);

// Reference blog: immediate + resize + 1s + 5s (in case images load longer)
resizeReferenceBlog();
window.addEventListener('resize', resizeReferenceBlog);
setTimeout(resizeReferenceBlog, 1000);
setTimeout(resizeReferenceBlog, 5000);

// Campaign detail similar: 100ms + 1s + 5s + resize
setTimeout(resizeSimilar, 100);
setTimeout(resizeSimilar, 1000);
setTimeout(resizeSimilar, 5000);
window.addEventListener('resize', resizeSimilar);

// Blog posts: immediate + 200ms + 500ms + 1s + 5s + resize (in case images load longer)
resizeBlogPosts();
setTimeout(resizeBlogPosts, 200);
setTimeout(resizeBlogPosts, 500);
setTimeout(resizeBlogPosts, 1000);
setTimeout(resizeBlogPosts, 5000);
window.addEventListener('resize', resizeBlogPosts);

// Career positions: resize + DOMContentLoaded
window.addEventListener('resize', adjustPositionHeight);
window.addEventListener('DOMContentLoaded', adjustPositionHeight);

// Collaboration campaigns: resize + DOMContentLoaded
window.addEventListener('resize', adjustCampaignHeight);
window.addEventListener('DOMContentLoaded', adjustCampaignHeight);
